<template>
  <div class="web-title">
    <div class="web-title-left">
      <div class="web-title-line"></div>
      <div class="web-title-title">
        <div class="web-title-chinese">{{titleChinese}}</div>
        <div class="web-title-english">{{titleEnglish}}</div>
      </div>
    </div>
    <div class="web-title-more" v-if="hasMore" @click="routerLink(titlePath,{id:titleId,name:titleChinese,type:'node',moreType:'node'})">更多>></div>
  </div>
</template>

<script>
  export default {
    name: "cms-title",
    props: {
      titleChinese: {
        type: String,
        default: ""
      },
      titleEnglish: {
        type: String,
        default: ""
      },
      hasMore: {
        type: Boolean,
        default: false
      },
      titlePath: {
        type: String,
        default: ""
      },
      titleId: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .web-title {
    height: 130px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .web-title-left {
    display: flex;
    align-items: center;
  }

  .web-title-line {
    width: 10px;
    height: 50px;
    background-color: #0861D1;
    border-radius: 2px;
  }

  .web-title-title {
    margin-left: 19px;
  }

  .web-title-chinese {
    height: 30px;
    font-size: 30px;
    font-weight: bold;
    font-family: Source Han Sans CN Bold;
    color: #0861D1;
    line-height: 30px;
  }

  .web-title-english {
    font-size: 18px;
    color: #8D8A8E;
  }

  .web-title-more {
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    color: #8D8A8E;
    cursor: pointer;
  }

  @media screen and (max-width: 800px) {
    .web-title {
      height: 98px;
    }

    .web-title-line {
      width: 8px;
      height: 48px;
    }

    .web-title-title {
      margin-left: 12px;
    }

    .web-title-chinese {
      font-size: 20px;
    }

    .web-title-english {
      font-size: 12px;
    }

    .web-title-more {
      height: 48px;
      line-height: 48px;
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Title.vue